export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Article.json?hash=06ccae385d7bce6090f5c4829d373d45";